import { render, staticRenderFns } from "./ScrollNum.vue?vue&type=template&id=4c2817b2"
import script from "./ScrollNum.vue?vue&type=script&lang=js"
export * from "./ScrollNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports